function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M2 1h12a1 1 0 011 1v12a1 1 0 01-1 1H2a1 1 0 01-1-1V2a1 1 0 011-1zm12-1a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2h12z",
  clipRule: "evenodd"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M5 15V1H4v14h1zm8-11.5a.5.5 0 00-.5-.5h-5a.5.5 0 000 1h5a.5.5 0 00.5-.5zm0 3a.5.5 0 00-.5-.5h-5a.5.5 0 000 1h5a.5.5 0 00.5-.5zm0 3a.5.5 0 00-.5-.5h-5a.5.5 0 000 1h5a.5.5 0 00.5-.5zm0 3a.5.5 0 00-.5-.5h-5a.5.5 0 000 1h5a.5.5 0 00.5-.5z",
  clipRule: "evenodd"
});

function SvgPortofolio(props) {
  return React.createElement("svg", _extends({
    className: "portofolio_svg__bi portofolio_svg__bi-layout-text-sidebar-reverse",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyBjbGFzcz0iYmkgYmktbGF5b3V0LXRleHQtc2lkZWJhci1yZXZlcnNlIiB3aWR0aD0iMWVtIiBoZWlnaHQ9IjFlbSIgdmlld0JveD0iMCAwIDE2IDE2IiBmaWxsPSJjdXJyZW50Q29sb3IiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMiAxaDEyYTEgMSAwIDAxMSAxdjEyYTEgMSAwIDAxLTEgMUgyYTEgMSAwIDAxLTEtMVYyYTEgMSAwIDAxMS0xem0xMi0xYTIgMiAwIDAxMiAydjEyYTIgMiAwIDAxLTIgMkgyYTIgMiAwIDAxLTItMlYyYTIgMiAwIDAxMi0yaDEyeiIgY2xpcC1ydWxlPSJldmVub2RkIi8+CiAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNSAxNVYxSDR2MTRoMXptOC0xMS41YS41LjUgMCAwMC0uNS0uNWgtNWEuNS41IDAgMDAwIDFoNWEuNS41IDAgMDAuNS0uNXptMCAzYS41LjUgMCAwMC0uNS0uNWgtNWEuNS41IDAgMDAwIDFoNWEuNS41IDAgMDAuNS0uNXptMCAzYS41LjUgMCAwMC0uNS0uNWgtNWEuNS41IDAgMDAwIDFoNWEuNS41IDAgMDAuNS0uNXptMCAzYS41LjUgMCAwMC0uNS0uNWgtNWEuNS41IDAgMDAwIDFoNWEuNS41IDAgMDAuNS0uNXoiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPgo8L3N2Zz4=";
export { SvgPortofolio as ReactComponent };